'use client';

import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { setOpenLocationSelectionModal } from '@/store/modal';
import { userLocationStore } from '@/store/user-location.store';
import { ContentContainer } from '@/components/ui/content-container.component';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const LocationSection = () => {
  const userLocation = useStore(userLocationStore, (state) => state.userLocation);
  const analytics = getAnalyticsPlugin();

  return (
    <>
      <section data-testid={DataTestIdEnum.CITY_LOCATION_BAR} className="bg-green-100 py-2 h-10">
        <ContentContainer>
          <Button
            data-testid={DataTestIdEnum.HOME_LOCATION_BAR_BUTTON}
            variant="text"
            startIcon={faLocationDot}
            className="w-auto"
            onClick={() => {
              if (!userLocation) {
                analytics.track(AnalyticsEnum.CLICK_INFORM_LOCATION);
              }
              setOpenLocationSelectionModal(true);
            }}
          >
            {userLocation ? `${userLocation.city} - ${userLocation.state}` : 'Informar localização'}
          </Button>
        </ContentContainer>
      </section>
    </>
  );
};
